import { HTMLUtils } from '@ssml-editor/utils';

function createElementAsString(nodeName, type, isInline, isVoid, dataAttributes, children) {
  if (typeof dataAttributes === "string") {
    children = dataAttributes;
  }
  if (typeof isVoid === "object") {
    dataAttributes = isVoid;
    isVoid = isInline;
  }
  if (typeof type === "boolean") {
    isInline = type;
    type = nodeName;
    if (isInline) {
      nodeName = "span";
    } else {
      nodeName = "div";
    }
  }
  return HTMLUtils.createElementAsString(
    nodeName,
    {
      "data-s-e-type": type,
      "data-s-e-inline": isInline,
      "data-s-e-void": isVoid,
      ...Object.fromEntries(
        Object.entries(dataAttributes).map(([key, value]) => [
          `data-${key}`,
          value
        ])
      )
    },
    children
  );
}
function getDataAttribute(element, attributeName, defaultValue) {
  return HTMLUtils.getAttribute(
    element,
    `data-${attributeName}`,
    defaultValue
  );
}
function getType(element, defaultValue) {
  return HTMLUtils.getAttribute(
    element,
    HTMLExtUtils.typeKey,
    defaultValue
  );
}
const HTMLExtUtils = {
  typeKey: "data-s-e-type",
  voidKey: "data-s-e-void",
  inlineKey: "data-s-e-inline",
  createElementAsString,
  getDataAttribute,
  getType,
  isVoid(element) {
    return HTMLUtils.getAttribute(element, this.voidKey, false);
  },
  isInline(element) {
    return HTMLUtils.getAttribute(element, this.inlineKey, false);
  }
};

export { HTMLExtUtils };
//# sourceMappingURL=html-ext-utils.js.map
